null


// WEBPACK FOOTER //
// /Volumes/workplace/commands/DescribeEntityRecognizerCommand.ts